import { IBodyExpertEntryTabsTypeParams } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyExpertTabs/getBodyExpertTabsQuery.type';
import { getBodyExpertTabsQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyExpertTabs/getBodyExpertTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyExpertTabsQueryOption = (
  params: IBodyExpertEntryTabsTypeParams,
) =>
  queryOptions({
    queryKey: ['get-body_expert_tabs', params],
    queryFn: () => getBodyExpertTabsQueryFunction(params),
  });
